import {
    FC,
    ReactElement,
    useEffect,
    useState,
} from 'react'

import EmptyList from '../../../components/EmptyList/EmptyList'
import { LoadingSpinner } from '../../components'
import { EventLog } from '../../entities/EventLog/EventLog'
import { ModalContent, PacoModal } from '../index'
import PacoDetailLogs from '../PacoDetailLogs/PacoDetailLogs'
import { generateLogsDateObject, LogsDateObjectProps } from './helpers'

import './PacoLogsModal.scss'

export interface PacoLogsModalProps {
    isLoading?: boolean;
    isOpen: boolean;
    logs: EventLog[];
    title: string;
    emptyMessage: string;
    onClose: () => void;
}

const PacoLogsModal: FC<PacoLogsModalProps> = ({
    isLoading = false,
    isOpen,
    logs,
    title,
    emptyMessage,
    onClose,
}): ReactElement => {
    const [logsDateObject, setLogsDateObject] = useState<LogsDateObjectProps>({})

    useEffect((): void => {
        if (logs) {
            setLogsDateObject(generateLogsDateObject(logs))
        }
    }, [logs])

    return (
        <div>
            {isOpen && (
                <PacoModal
                    isWide
                    onClose={onClose}
                    className="paco-logs-modal"
                >
                    {logs.length > 0 && (
                        <ModalContent
                            title={title}
                            showCloseButton
                            onCloseButtonClick={onClose}
                        >
                            {Object.values(logsDateObject).map(logsInDate => (
                                <PacoDetailLogs
                                    key={logsInDate[0].id}
                                    isFirstLogActive={logsInDate[0].id === logs[0].id}
                                    detailLogs={logsInDate}
                                    className="paco-logs-modal__detail-logs"
                                />
                            ))}
                        </ModalContent>
                    )}

                    {! isLoading && logs.length === 0 && (
                        <ModalContent
                            title={title}
                            showCloseButton
                            onCloseButtonClick={onClose}
                            className="paco-logs-modal__zero-modal-content"
                        >
                            <EmptyList
                                text={emptyMessage}
                                className="paco-logs-modal__zero-logs"
                            />
                        </ModalContent>
                    )}
                </PacoModal>
            )}

            {isLoading && <LoadingSpinner />}
        </div>
    )
}

export default PacoLogsModal
